import React from 'react';
// import Footer from '../../Footer';
import { Widget } from '@typeform/embed-react';

function Contact() {
    return (
        <div className='contact-page'>
            <Widget
                id='sEcpICFP'
                style={{
                    width: '100%',
                    height: '100vh'
                }}
            />
            {/* <Footer /> */}
        </div>
    );
}

export default Contact;
